import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    TransitionChild,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { LivePreviewSidebar } from "./LivePreviewSidebar";
import { Logo } from "@/components/Icons";
import { AppText } from "@/components/Text/AppText";

interface MobileSidebarProps {
    sidebarOpen: boolean;
    setSidebarOpen: (open: boolean) => void;
    activeTemplateId: string | null;
    setActiveTemplateId: (id: string | null) => void;
}

export const MobileSidebar = ({
    sidebarOpen,
    setSidebarOpen,
    activeTemplateId,
    setActiveTemplateId,
}: MobileSidebarProps) => {
    return (
        <>
            <Dialog
                open={sidebarOpen}
                onClose={setSidebarOpen}
                className="relative z-50 lg:hidden"
            >
                <DialogBackdrop
                    transition
                    className="data-closed:opacity-0 fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear"
                />
                <div className="fixed inset-0 flex">
                    <TransitionChild
                        enter="transform transition duration-300 ease-in-out"
                        enterFrom="-translate-x-full"
                        enterTo="translate-x-0"
                        leave="transform transition duration-300 ease-in-out"
                        leaveFrom="translate-x-0"
                        leaveTo="-translate-x-full"
                    >
                        <DialogPanel className="relative mr-16 flex w-full max-w-xs flex-1">
                            <div className="data-closed:opacity-0 absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out">
                                <button
                                    type="button"
                                    onClick={() => setSidebarOpen(false)}
                                    className="-m-2.5 p-2.5"
                                >
                                    <span className="sr-only">
                                        Close sidebar
                                    </span>
                                    <XMarkIcon
                                        aria-hidden="true"
                                        className="size-6 text-white"
                                    />
                                </button>
                            </div>
                            <LivePreviewSidebar
                                activeTemplateId={activeTemplateId}
                                setActiveTemplateId={setActiveTemplateId}
                            />
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </Dialog>

            {/* Mobile top bar */}
            <div className="shadow-xs sticky top-0 z-40 flex items-center justify-between gap-x-6 bg-white px-4 py-4 sm:px-6 lg:hidden">
                <button
                    type="button"
                    onClick={() => setSidebarOpen(true)}
                    className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
                >
                    <span className="sr-only">Open sidebar</span>
                    <Bars3Icon
                        aria-hidden="true"
                        className="size-6"
                    />
                </button>
                <a
                    className="flex items-center gap-2"
                    href="https://www.1template.io"
                    target="_blank"
                    rel="noreferrer"
                >
                    <AppText
                        variant="contextheading"
                        className="!font-medium text-primary-900"
                    >
                        Powered by
                    </AppText>
                    <Logo className="h-5 w-auto" />
                </a>
            </div>
        </>
    );
};
